import {
    EventParticipantResult,
    EventResult,
    FocusContainerSummaryDto,
    ObservationSummaryDto,
} from '../../coaching-base/general';

export interface ObservationFormValue {
    event: EventResult;
    eventParticipants: EventParticipantResult[];
    focusContainers: FocusContainerSummaryDto[];
    diffItemId?: string;
}

export function observationFormValueTransformer(
    model: ObservationSummaryDto,
): ObservationFormValue {
    return {
        event: model.event,
        eventParticipants: model.eventParticipants,
        focusContainers: model.focusContainers || [],
        diffItemId: model.diffItemId,
    };
}
